export default __webpack_public_path__ + "static/media/bg_orange.f039b2ba.svg";